import es from './es'
import en from './en'

const languages = { es, en }

export default languages